import React from 'react';
import withOnboarding from './withOnboarding';
import SVGChevron from '../../svg/Chevron';

class OnboardingNavItem extends React.Component {
  state = {};

  render() {
    const { step, subject, extras, isMobile } = this.props;
    const { navComponent: NavComponent, navLabel } = step;
    let formattedLabel = navLabel;
    let chev = '';

    // only show the steps the math on mobile
    if (isMobile) {
      const totalSteps = this.props.steps.length;
      const prefix = isMobile ? `${step.step + 1}/${totalSteps}` : '';
      formattedLabel = prefix ? `${prefix}: ${navLabel}` : navLabel;
    }

    if (isMobile && !this.props.isOpen)
      chev = (
        <div className="on-boarding-nav-item__chev">
          <span className="chev">
            <SVGChevron />
          </span>
        </div>
      );

    return (
      <div className="on-boarding-nav-item__content">
        <div className="on-boarding-nav-item__label">{formattedLabel}</div>
        {chev}
        {NavComponent && (
          <NavComponent
            className="on-boarding-nav-item__body"
            subject={subject}
            extras={extras}
            isMobile={isMobile}
          />
        )}
      </div>
    );
  }
}
export default withOnboarding(OnboardingNavItem);



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingNavItem.js